// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"889fd6c9","706":"8365d322"}[chunkId] + ".chunk.css";
};